<template>
  <v-img :src="logo_url"  class="rounded"/>
</template>
<script>
export default {
  name: 'CardLogo',

  props: ['brand'],

  data() {
    return {
      publicPath: process.env.BASE_URL,
    }
  },

  computed: {
    logo_url() {
      switch(this.brand.toLowerCase()) {
        case 'amex':
          return this.publicPath + 'cards/American-Express-02.svg'
        case 'discover':
          return this.publicPath + 'cards/Discover-Card-01.svg'
        case 'mastercard':
          return this.publicPath + 'cards/mc_symbol.svg'
        case 'visa':
          return this.publicPath + 'cards/Visa_Brandmark_Blue_RGB_2021.svg'
        default:
          return ''
      }
    }
  },
}
</script>